import React from 'react'
import RootWrapper from './src/RootWrapper'

export const wrapRootElement = ({ element }) => <RootWrapper>{element}</RootWrapper>